import DatetimeParser from '../../model/parser/datetime-parser'

export class SchedulerEventValueObject {
  static eventTypeTask = 1
  static eventTypeWork = 2

  static IDtTask          = 'IDtTask'
  static idtActivity      = 'idtActivity'
  static IDtUserGroup     = 'IDtUserGroup'
  static ResourceID       = 'ResourceID'
  static ResourceTable    = 'ResourceTable'
  static tTask_SearchText = 'tTask_SearchText'
  static BeginDateSched   = 'BeginDateSched'
  static EndDateSched     = 'EndDateSched'
  static DateFrom         = 'DateFrom'
  static DateTo           = 'DateTo'
  static tTaskStatusColor = 'tTaskStatusColor'
  static tEntityCode      = 'tEntityCode'
  static statusBadge      = 'EventsStatusBadge'
  static statusColor      = 'EventsStatusColor'
  static typeName         = 'EventsTypeName'
  static typeColor        = 'EventsTypeColor'
  static badge            = 'EventsBadge'
  static description      = 'EventsDescription'
  static idtEntity        = 'idtEntity'
  static eventType        = 'EventsType'
  static rowId            = 'ID'

  constructor (
    id,
    idActivity,
    idUserGroup,
    name,
    beginDate,
    endDate,
    color,
    entityCode,
    statusBadge,
    statusColor,
    typeName,
    typeColor,
    badge,
    description,
    idtEntity,
    resourceTable,
    eventType,
    originalResourceId
  ) {
    this._id                 = id
    this._idActivity         = idActivity
    this._idUserGroup        = idUserGroup
    this._name               = name
    this._beginDate          = beginDate
    this._endDate            = endDate
    this._color              = color
    this._entityCode         = entityCode
    this._statusBadge        = JSON.parse(statusBadge)
    this._statusColor        = statusColor
    this._typeName           = typeName
    this._typeColor          = typeColor
    this._badge              = JSON.parse(badge)
    this._description        = description
    this._idtEntity          = idtEntity
    this._resourceTable      = resourceTable
    this._eventType          = eventType
    this._originalResourceId = originalResourceId !== null
      ? parseInt(originalResourceId)
      : null
  }

  get endDate () {
    return this._endDate
  }

  set endDate (value) {
    this._endDate = value
  }

  get beginDate () {
    return this._beginDate
  }

  set beginDate (value) {
    this._beginDate = value
  }

  get name () {
    return this._name
  }

  set name (value) {
    this._name = value
  }

  get idUserGroup () {
    return this._idUserGroup
  }

  set idUserGroup (value) {
    this._idUserGroup = value
  }

  get id () {
    return this._id
  }

  get idActivity () {
    return this._idActivity
  }

  get entityCode () {
    return this._entityCode
  }

  get color () {
    return this._color
  }

  get description () {
    return this._description
  }

  get badge () {
    return this._badge
  }

  get typeColor () {
    return this._typeColor
  }

  get typeName () {
    return this._typeName
  }

  get statusColor () {
    return this._statusColor
  }

  get statusBadge () {
    return this._statusBadge
  }

  get idtEntity () {
    return this._idtEntity
  }

  get originalResourceId () {
    return this._originalResourceId
  }

  get resourceTable () {
    return this._resourceTable
  }

  get eventType () {
    return this._eventType
  }

  /**
   *
   * @param apiObject
   * @returns {SchedulerEventValueObject}
   */
  static fromApiObject (apiObject) {
    return new SchedulerEventValueObject(
      apiObject[SchedulerEventValueObject.IDtTask],
      apiObject[SchedulerEventValueObject.idtActivity],
      apiObject.hasOwnProperty(SchedulerEventValueObject.IDtUserGroup)
        ? apiObject[SchedulerEventValueObject.IDtUserGroup]
        : apiObject[SchedulerEventValueObject.ResourceID],
      apiObject[SchedulerEventValueObject.tTask_SearchText],
      apiObject[SchedulerEventValueObject.BeginDateSched],
      apiObject[SchedulerEventValueObject.EndDateSched],
      apiObject[SchedulerEventValueObject.tTaskStatusColor],
      apiObject[SchedulerEventValueObject.tEntityCode],
      apiObject[SchedulerEventValueObject.statusBadge],
      apiObject[SchedulerEventValueObject.statusColor],
      apiObject[SchedulerEventValueObject.typeName],
      apiObject[SchedulerEventValueObject.typeColor],
      apiObject[SchedulerEventValueObject.badge],
      apiObject[SchedulerEventValueObject.description],
      apiObject[SchedulerEventValueObject.idtEntity],
      apiObject[SchedulerEventValueObject.ResourceTable],
      apiObject[SchedulerEventValueObject.eventType],
      null
    )
  }

  /**
   *
   * @param row
   * @returns {SchedulerEventValueObject}
   */
  static fromRowData (row) {
    return new SchedulerEventValueObject(
      row[SchedulerEventValueObject.rowId],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null
    )
  }

  /**
   *
   * @param calendarEventObject {EventApi}
   * @param resourceId {Number|null}
   * @param viewType {string|null}
   * @param originalResourceId
   * @returns {SchedulerEventValueObject}
   */
  static fromCalendarObject (
    calendarEventObject,
    resourceId         = null,
    viewType           = null,
    originalResourceId = null
  ) {
    let startDate     = null,
        endDate       = null,
        groupId       = parseInt(resourceId),
        calEventStart = calendarEventObject.start,
        calEventEnd   = calendarEventObject.end

    if (calendarEventObject.start.getHours() === 0 &&
      calendarEventObject.start.getMinutes() === 0 &&
      calendarEventObject.start.getSeconds() === 0) {
      calEventStart = new Date(calendarEventObject.start.setHours(8, 0, 0))
    }

    if ((!calendarEventObject.end || viewType !== 'resourceTimelineDay' ||
      (calendarEventObject.end.getHours() === 0 &&
        calendarEventObject.end.getMinutes() === 0 &&
        calendarEventObject.end.getSeconds() === 0))
      && calendarEventObject.extendedProps.hasOwnProperty('duration')) {
      const duration = calendarEventObject.extendedProps.duration
      calEventEnd    = moment(calEventStart.getTime())
        .add(duration, 'hours')
    }

    if (calendarEventObject.start) {
      startDate = DatetimeParser.dateObjectToISO(calEventStart)
    }

    if (calendarEventObject.end &&
      (viewType === 'resourceTimelineDay' || viewType === null)) {
      endDate = DatetimeParser.dateObjectToISO(calendarEventObject.end)
    }
    else {
      endDate = DatetimeParser.dateObjectToISO(calEventEnd)
    }

    if (calendarEventObject.extendedProps.propResourceId && !resourceId) {
      groupId = parseInt(calendarEventObject.extendedProps.propResourceId)
    }

    return new SchedulerEventValueObject(
      calendarEventObject.id ? parseInt(calendarEventObject.id) : null,
      calendarEventObject.extendedProps.hasOwnProperty('idActivity')
        ? calendarEventObject.extendedProps.idActivity
        : null,
      groupId,
      calendarEventObject.title,
      startDate,
      endDate,
      null,
      calendarEventObject.extendedProps.entityCode,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      originalResourceId
    )
  }

  /**
   *
   * @returns {{}}
   */
  toApiObject () {
    let output = {}

    output[SchedulerEventValueObject.IDtTask]          = this.id
    output[SchedulerEventValueObject.idtActivity]      = this.idActivity
    output[SchedulerEventValueObject.IDtUserGroup]     = this.idUserGroup
    output[SchedulerEventValueObject.ResourceID]       = this.idUserGroup
    output[SchedulerEventValueObject.tTask_SearchText] = this.name
    output[SchedulerEventValueObject.BeginDateSched]   = this.beginDate
    output[SchedulerEventValueObject.EndDateSched]     = this.endDate
    output[SchedulerEventValueObject.DateFrom]         = this.beginDate
    output[SchedulerEventValueObject.DateTo]           = this.endDate

    return output
  }

  toApiObjectUpperCased () {
    const output    = {}
    const originals = this.toApiObject()

    Object
      .keys(originals)
      .forEach((key) => {
        output[key.toUpperCase()] = originals[key]
      })

    return output
  }
}
